import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Payment from '../entities/payment'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface PaymentState extends ListState<Payment> {
    editPayment: Payment;
}
class PaymentModule extends ListModule<PaymentState, any, Payment>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Payment>(),
        loading: false,
        editPayment: new Payment()
    }
    actions = {
        async getAll(context: ActionContext<PaymentState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Payment/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Payment>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<PaymentState, any>, payload: any) {
            await Ajax.post('/api/services/app/Payment/Create', payload.data);
        },
        async update(context: ActionContext<PaymentState, any>, payload: any) {
            await Ajax.put('/api/services/app/Payment/Update', payload.data);
        },
        async delete(context: ActionContext<PaymentState, any>, payload: any) {
            await Ajax.delete('/api/services/app/Payment/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<PaymentState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Payment/Get?Id=' + payload.id);
            return reponse.data.result as Payment;
        },
        async continueToRecharge(context: ActionContext<PaymentState, any>, payload: any) {
            await Ajax.post('/api/services/app/Payment/ContinueToRecharge' , payload.data);
        }
    };
    mutations = {
        setCurrentPage(state: PaymentState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: PaymentState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: PaymentState, payment: Payment) {
            state.editPayment = payment;
        }
    }
}
const paymentModule = new PaymentModule();
export default paymentModule;